const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
)

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing

        if (!installingWorker) {
          return
        }

        installingWorker.onstatechange = () => {
          if (installingWorker.state !== 'installed') {
            return
          }

          if (navigator.serviceWorker.controller) {
            if (config && config.onUpdate) {
              config.onUpdate(registration)
            }

            return
          }

          if (config && config.onSuccess) {
            config.onSuccess(registration)
          }
        }
      }
    })
    .catch((error) => {
      console.error('Error al registrar el service worker:', error)
    })
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      const contentType = response.headers.get('content-type')

      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload()
          })
        })

        return
      }

      registerValidSW(swUrl, config)
    })
    .catch(() => {
      // Si no hay red, la app puede seguir funcionando con el cache existente.
    })
}

export function register(config) {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return
  }

  const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href)

  if (publicUrl.origin !== window.location.origin) {
    return
  }

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`

    if (isLocalhost) {
      checkValidServiceWorker(swUrl, config)

      navigator.serviceWorker.ready.then(() => {
        console.info('PWA lista: el contenido se servira desde cache cuando no haya red.')
      })

      return
    }

    registerValidSW(swUrl, config)
  })
}

export function unregister() {
  if (!('serviceWorker' in navigator)) {
    return
  }

  navigator.serviceWorker.ready
    .then((registration) => {
      registration.unregister()
    })
    .catch((error) => {
      console.error(error.message)
    })
}